import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Container, Tab, Tabs } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useWebsiteName } from "../../../context/WebsiteNameContext";
import handleChangeWebsiteTab from "../../../commons/ChangeWebsiteTab";
import SearchRepairForm from "./search";
import CreateRepairWorkOrders from "./create";

export default function IssueWorkOrderRepair() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { websiteName, setWebsiteName } = useWebsiteName();

  const handleChangeTab = (key) => {
    if (key === "request") navigate("/reimbursement_refund");
    else
      handleChangeWebsiteTab({
        key,
        setWebsiteName,
        tabNames: {
          create: "ออกใบสั่งงานแจ้งซ่อม",
          search: "ข้อมูลใบสั่งงานแจ้งซ่อม"
        },
        navigated: (navi) =>
          navi &&
          state?.name !== key &&
          navigate("/repair_work/issue", { state: { name: key } })
      });
  };

  useEffect(() => handleChangeTab(state?.name || "create"), []);

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Issue a repair work order Page" />
      </Helmet>
      <Container fluid className="p-0">
        <Tabs
          justify
          defaultActiveKey={state?.name || "create"}
          onSelect={(k) => handleChangeTab(k)}
        >
          <Tab eventKey="create" title="ออกใบสั่งงานแจ้งซ่อม">
            {websiteName === "ออกใบสั่งงานแจ้งซ่อม" && (
              <CreateRepairWorkOrders />
            )}
          </Tab>
          <Tab eventKey="search" title="ข้อมูลใบสั่งงานแจ้งซ่อม">
            {websiteName === "ข้อมูลใบสั่งงานแจ้งซ่อม" && <SearchRepairForm />}
          </Tab>
          <Tab eventKey="request" title="ใบขอเบิกงานแจ้งซ่อม"></Tab>
        </Tabs>
      </Container>
    </>
  );
}
